<template>
  <div class="fields">
    <header class="b-header">
      <h2 style="margin-bottom:0">{{$t('choose_field')}}</h2>
    </header>
    <main class="b-main">
      <Questionnaires v-bind:quests="questData" v-bind:curAge="kidsAgeM" />
    </main>
  </div>
</template>

<i18n>
  {
  "el": {
  "choose_field": "Επιλέξτε Πεδίο"
  },
  "en": {
  "choose_field": "Choose a field"
  }
  }
</i18n>

<script>
import { mapState } from 'vuex'
import Questionnaires from '@/components/Questionnaires.vue'
import i18n from '../i18n'

export default {
  name: 'Fields',
  title: i18n.locale === 'en' ? 'Fields' : 'Τομείς',
  inherit: true,
  components: {
    Questionnaires
  },
  computed: {
    ...mapState(['kidsAgeM', 'questData'])
  }
}
</script>
